import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "cart-parts__value-kopecks"
};
import { computed, onUnmounted, ref, watch } from 'vue';
import { format } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Price',
    props: {
        amount: Number,
        fixedWidth: Boolean,
        skipCurrency: Boolean,
        long: Boolean,
        showFractions: { type: [Boolean, String] },
    },
    setup: function (__props) {
        var props = __props;
        var wrapper = ref();
        var displayedAmount = ref(props.amount);
        var transitionTime = props.long ? 750 : 150;
        var transition = {
            startAmount: 0,
            endAmount: 0,
            timeEnd: 0,
            running: false,
        };
        var animationFrameRequestId;
        var fraction = computed(function () {
            if (!props.amount || !props.showFractions) {
                return '';
            }
            var fraction = parseFloat(props.amount.toString()).toFixed(2).toString().split('.')[1];
            if (props.showFractions === 'auto' && fraction === '00') {
                return '';
            }
            return fraction;
        });
        function step(time) {
            var _a;
            if (props.fixedWidth) {
                var minWidth = parseInt((_a = getComputedStyle(wrapper.value).minWidth) !== null && _a !== void 0 ? _a : '0');
                if (wrapper.value.clientWidth > minWidth) {
                    wrapper.value.style.minWidth = "".concat(wrapper.value.clientWidth, "px");
                }
            }
            if (!transition.running) {
                transition.timeEnd = time + transitionTime;
                transition.running = true;
            }
            var progress = (transition.timeEnd - time) / transitionTime;
            if (progress <= 0) {
                displayedAmount.value = transition.endAmount;
                transition.running = false;
                return;
            }
            displayedAmount.value = Math.round((1 - progress) * (transition.endAmount - transition.startAmount) + transition.startAmount);
            animationFrameRequestId = requestAnimationFrame(step);
        }
        watch(function () { return props.amount; }, function (newAmount, oldAmount) {
            if (newAmount !== oldAmount) {
                transition.endAmount = newAmount;
                transition.startAmount = displayedAmount.value;
                if (!transition.running) {
                    transition.timeEnd = 0;
                    animationFrameRequestId = requestAnimationFrame(step);
                }
            }
        });
        onUnmounted(function () {
            if (animationFrameRequestId) {
                cancelAnimationFrame(animationFrameRequestId);
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("span", {
                ref_key: "wrapper",
                ref: wrapper
            }, [
                _createTextVNode(_toDisplayString(_unref(format)(displayedAmount.value)), 1 /* TEXT */),
                (fraction.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "." + _toDisplayString(fraction.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (!__props.skipCurrency)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" ₽")
                    ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */));
        };
    }
});
